export default "__VITE_ASSET__DSRRZJA9__"